/* eslint-disable no-console */
import store from "@/store";
import router from "@/router";
import moment from "moment";
const axios = require("axios");
var configSettings = require("../config/config.json");

import "dotenv/config";

const responseCategories = {
   Info: 0,
   Success: 1,
   Warning: 2,
   Error: 3,
};

let dataCash = {};

function ApiUrl(path) {
   let apiUrl = process.env.VUE_APP_API_URL;

   // If no env variable, try config file (but not if it's a placeholder)
   if (!apiUrl || apiUrl === "undefined") {
      if (configSettings.API_URL && !configSettings.API_URL.includes("DEFAULT_API_URL")) {
         apiUrl = configSettings.API_URL;
      }
   }

   // Preserve an explicit protocol, but default to HTTPS for bare hostnames.
   if (apiUrl && !/^https?:\/\//.test(apiUrl)) {
      apiUrl = "https://" + apiUrl;
   }

   return apiUrl + "/api/" + path;
}

function defaultConfig() {
   const idToken = router.app.$auth.getIdToken();

   return {
      headers: { Authorization: `Bearer ${idToken}` },
   };
}

function handleError(error) {
   if (error.response && error.response.status == 401) {
      router.push("/auth");
   } else {
      store.commit("setLastError", error);
      router.push("/error");
   }
}

function handleStandardResponseMessages(response) {
   if (response.resultCategory >= 0) {
      switch (response.resultCategory) {
         case responseCategories.Success:
            window.vm.$root.$emit("showMessage", { type: "success", predefined: response.resultType });
            break;
         case responseCategories.Info:
            window.vm.$root.$emit("showMessage", { type: "info", predefined: response.resultType });
            break;
         case responseCategories.Warning:
            window.vm.$root.$emit("showMessage", { type: "warning", predefined: response.resultType });
            break;
         case responseCategories.Error:
            window.vm.$root.$emit("showMessage", {
               text: response.message,
               type: "error",
               predefined: response.resultType,
            });
            break;
         default:
            break;
      }
   }
}

function convertDates(obj) {
   for (var prop in obj) {
      if (typeof obj[prop] == "string") {
         //iso date?
         var patt = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;

         var isDate = patt.exec(obj[prop]);
         if (isDate) {
            obj[prop] = moment.utc(obj[prop]).toDate();
         }
      } else if (typeof obj[prop] == "object") {
         obj[prop] == convertDates(obj[prop]);
      }
   }

   return obj;
}

export function apiGet(path, config) {
   console.log("get:" + path);
   return new Promise((resolve, reject) => {
      axios
         .get(ApiUrl(path), config || defaultConfig())
         .then(function (response) {
            resolve(convertDates(response.data));
         })
         .catch(function (error) {
            handleError(error);
            reject(error);
         });
   });
}

export function apiCashedGet(path, config) {
   return new Promise((resolve, reject) => {
      if (dataCash.hasOwnProperty(path)) {
         resolve(dataCash[path]);
      } else {
         apiGet(path, config)
            .then((data) => {
               dataCash[path] = data;
               resolve(data);
            })
            .catch(function (error) {
               reject(error);
            });
      }
   });
}

export function apiGetExternal(url, config) {
   console.log("get:" + url);
   return new Promise((resolve, reject) => {
      axios
         .get(url, config)
         .then(function (response) {
            resolve(response.data);
         })
         .catch(function (error) {
            reject(error);
         });
   });
}

export function apiPostExternal(url, data, config) {
   console.log("post:" + url);
   return new Promise((resolve, reject) => {
      axios
         .post(url, data, config)
         .then(function (response) {
            resolve(response.data);
         })
         .catch(function (error) {
            reject(error);
         });
   });
}

export function apiPost(path, data) {
   console.log("post:" + path);
   return new Promise((resolve, reject) => {
      axios
         .post(ApiUrl(path), data, defaultConfig())
         .then(function (response) {
            resolve(convertDates(response.data));
         })
         .catch(function (error) {
            // handleError(error);
            reject(error);
         });
   });
}

export function apiPut(path, data) {
   console.log("put:" + path);
   return new Promise((resolve, reject) => {
      axios
         .put(ApiUrl(path), data, defaultConfig())
         .then(function (response) {
            handleStandardResponseMessages(response.data);
            resolve(convertDates(response.data));
         })
         .catch(function (error) {
            handleError(error);
            reject(error);
         });
   });
}

export function apiDelete(path, data) {
   console.log("delete:" + path);
   return new Promise((resolve, reject) => {
      let config = defaultConfig();
      if (data) {
         config.data = data;
      }
      axios
         .delete(ApiUrl(path), config)
         .then(function (response) {
            handleStandardResponseMessages(response.data);
            resolve(convertDates(response.data));
         })
         .catch(function (error) {
            handleError(error);
            reject(error);
         });
   });
}
